export function getDay(addDays = 0, time = "00:00") {
    const date = new Date();
    date.setDate(date.getDate() + addDays);

    return date.toISOString().slice(0, 10) + "T" + time;
}

export function getUserPermissions(usersHashId: string, users: Record<string, { isMember?: boolean, isAdmin?: boolean }>) {
    const isTeamMember = !!usersHashId && users[usersHashId]?.isMember === true;
    const isTeamAdmin = !!usersHashId && users[usersHashId]?.isAdmin === true;

    return { isTeamMember, isTeamAdmin };
}
